import React from 'react';
import { Box, Typography, Button, CardContent } from '@mui/material';
import PrimaryButton from '../PrimaryButton';
import CustomCard from '../CustomCard';
interface TourSlot {
  id: string;
  date: string;
  start_time_local: string;
  end_time_local: string;
  available_spots: number;
}

interface TourConfirmationScreenProps {
  selectedTimeSlot: TourSlot | null;
  formatDate: (dateString: string) => string;
  formatTime: (timeString: string) => string;
  onChangeTourTime: () => void;
  onContinue: () => void;
  isMobile: boolean;
  isCustomer?: boolean;
  propertyAddress: string;
}

const TourConfirmationScreen: React.FC<TourConfirmationScreenProps> = ({
  selectedTimeSlot,
  formatDate,
  formatTime,
  onChangeTourTime,
  onContinue,
  isMobile,
  isCustomer = false,
  propertyAddress,
}) => (
  <Box
    sx={{
      minHeight: '100vh',
      width: '100%',
      maxWidth: '100%',
      display: 'flex',
      flexDirection: 'column',
      alignItems: isMobile ? 'left' : 'center',
      justifyContent: 'flex-start',
      marginTop: 0,
      padding: isMobile ? '1rem' : '2rem',
      overflowX: 'hidden',
      boxSizing: 'border-box',
    }}
  >

    <Typography variant="h6" sx={{ mb: 2, fontWeight: 500, color: 'text.primary' }}>
      Tour date selected:
    </Typography>
    {selectedTimeSlot && (
      <Box sx={{
        backgroundColor: '#e3f2fd',
        border: '2px solid #1976d2',
        borderRadius: '12px',
        padding: '16px 20px',
        mb: 3,
        textAlign: 'center',
        boxShadow: '0 2px 8px rgba(25, 118, 210, 0.15)'
      }}>
        <Typography variant="body1" sx={{ 
          fontWeight: 600, 
          color: '#1976d2',
          fontSize: '1.1rem'
        }}>
          📅 {formatDate(selectedTimeSlot.date)}, at {formatTime(selectedTimeSlot.start_time_local)}
        </Typography>
      </Box>
    )}


    {/* Change Time Button */}
    <Button
      variant="text"
      size="small"
      onClick={onChangeTourTime}
      sx={{
        color: '#1976d2',
        fontWeight: 500,
        textTransform: 'none',
        fontSize: '0.95rem',
        margin: '0 auto',
        marginTop: '1rem',
        mb: 3,
        '&:hover': {
          textDecoration: 'underline',
          background: 'none',
        },
      }}
    >
      Change Time
    </Button>

    <Typography variant="body1" sx={{ mb: 1, fontWeight: 400, color: 'text.primary' }}>
      {isCustomer ? 'Confirm your tour cancellation' : 'Help the housing provider know you better by answering a few short questions.'}
    </Typography>
    <Typography variant="body1" sx={{ mb: 3, fontWeight: 400, color: 'text.primary' }}>
      Its quick and easy!
    </Typography>

    {/* Continue Button */}
    <PrimaryButton
      onClick={onContinue}
      sx={{
        mt: 4,
        padding: '9px 26px',
        fontSize: '1.15rem',
        margin: '0 auto',
        maxWidth: { xs: '200px', sm: '300px' },
        width: { xs: 'auto', sm: 'auto' },
        fontWeight: 500,
      }}
    >
      {'Start Questions'}
    </PrimaryButton>
  </Box>
);

export default TourConfirmationScreen;